<script setup lang="ts">
    defineOptions({ name: 'DefaultLayout' });

    const showPTAPostLoginModal = ref(false);

    onMounted(() => {
        showPTAPostLoginModal.value = consumePTAFamilyLoginFlag();
    });

    const { showDraftModeToggle } = useDraftMode();
</script>

<template>
    <div class="body-wrapper">
        <div>
            <LayoutHeader>
                <template #custom-user-actions>
                    <AccountMenu />
                    <HeaderCart />
                </template>
            </LayoutHeader>
            <LayoutNotifications />
            <main class="mx-auto">
                <slot />
            </main>
            <RedirectModal />
            <ClientOnly>
                <PTAPostLoginModal v-if="showPTAPostLoginModal" />
            </ClientOnly>
        </div>

        <LayoutFooter />

        <DraftModeToggle v-if="showDraftModeToggle" />

        <RouteToastHandler />
    </div>
</template>
